/**
 * Returns the PDP gallery to the product hero when a selected variant has no
 * featured image. Variants with their own media remain handled by Prestige.
 */
(function () {
  if (window.__ileeraGalleryHeroFallback) {
    return;
  }
  window.__ileeraGalleryHeroFallback = true;

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || variant.featured_media) {
      // Prestige handles variants that have their own media.
      return;
    }

    // Read the form id from the event target to avoid named-field shadowing.
    var form = event.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!formId) {
      return;
    }

    var gallery = document.querySelector('product-gallery[form="' + CSS.escape(formId) + '"]');
    if (!gallery) {
      return;
    }

    var fallbackMediaId = gallery.getAttribute('data-ileera-hero-fallback-media-id');
    var fallbackPositionAttr = gallery.getAttribute('data-ileera-hero-fallback-position');
    if (!fallbackMediaId || !fallbackPositionAttr) {
      // No configured product hero.
      return;
    }

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) {
      return;
    }

    var position = parseInt(fallbackPositionAttr, 10) - 1;
    if (Number.isNaN(position)) {
      return;
    }

    // Keep the same filtered-index calculation used by the native gallery.
    var filteredIndexes = [];
    try {
      filteredIndexes = JSON.parse(gallery.getAttribute('filtered-indexes') || '[]').map(function (index) {
        return parseInt(index, 10) - 1;
      });
    } catch (err) {
      filteredIndexes = [];
    }
    var filteredIndexBelowPosition = filteredIndexes.filter(function (index) {
      return index < position;
    });

    if (carousel.isScrollable && typeof carousel.select === 'function') {
      carousel.select(position - filteredIndexBelowPosition.length, { instant: true });
    } else {
      var slide = gallery.querySelector('[data-media-id="' + CSS.escape(fallbackMediaId) + '"]');
      if (slide) {
        slide.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  });
})();

